<template>
  <div class="caseInfo">
    <!-- 返回上一页按钮 -->
    <template v-if="isRefreshBtn">
      <span
        class="el-back"
        @click="back"
      ><i
        class="el-icon-refresh-left"
      /></span>
    </template>

    <div class="title-line">
      <span
        class="divider-title"
      >请选择邮件类型(<span
        style="color: red; margin-left: 5px; margin-right: 5px"
      >*已设置定时邮件，可到定时邮件列表查看和撤回</span>
        )</span>
      <el-divider />
    </div>
    <el-tabs v-model="activeTab" type="border-card" @tab-click="changeTab">
      <el-tab-pane
        v-if="tabInArray('tab01')"
        name="tab01"
        :label="
          (caseCode != '' || checkPermission('邮件:首次材料邮件', permList)) +
            ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />首次材料邮件</span>
        <p v-if="isShowTabContent" style="margin: 25px 15px 15px">邮件内容:</p>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>
      <el-tab-pane
        v-if="tabInArray('tab02')"
        name="tab02"
        :label="
          (caseCode != '' || checkPermission('邮件:补充材料邮件', permList)) +
            ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />补充材料邮件</span>
        <div v-if="isShowTabContent" style="margin: 25px 15px 15px">
          <p>请填写需要会员补充资料的信息:</p>
          <el-input
            v-model="templateInfo.addContent"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="请填写需要会员补充资料的信息"
          />
        </div>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>
      <el-tab-pane
        v-if="tabInArray('tab03')"
        name="tab03"
        :label="
          (caseCode != '' || checkPermission('邮件:立案收费邮件', permList)) +
            ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />立案收费邮件</span>
        <br>
        <div v-if="isShowTabContent" class="search-con">
          <!-- <div class="search-con-item">
            <label class="search-con-item__label">最高互助金额:</label>
            <span
              ><el-input
                placeholder="最高互助金额"
                v-model="templateInfo.maxHelpMoney"
              ></el-input
            ></span>
            <span style="color: #99a9bf; margin-right: 10px; margin-left: 10px"
              >元</span
            >
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">低度互助金额:</label>
            <span
              ><el-input
                placeholder="低度互助金额"
                v-model="templateInfo.minHelpMoney"
              ></el-input
            ></span>
            <span style="color: #99a9bf; margin-right: 10px; margin-left: 10px"
              >元</span
            >
          </div> -->
          <div class="search-con-item">
            <label class="search-con-item__label">调查费用:</label>
            <span><el-input
              v-model="templateInfo.surveyMoney"
              placeholder="调查费用"
            /></span>
            <span
              style="color: #99a9bf; margin-right: 10px; margin-left: 10px"
            >元</span>
          </div>
        </div>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>

      <el-tab-pane
        v-if="tabInArray('tab06')"
        name="tab06"
        :label="
          (caseCode != '' || checkPermission('邮件:通知调查邮件', permList)) +
            ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />通知调查邮件</span>
        <p v-if="isShowTabContent" style="margin: 25px 15px 15px">邮件内容:</p>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>
      <el-tab-pane
        v-if="tabInArray('tab07')"
        name="tab07"
        :label="
          (caseCode != '' || checkPermission('邮件:低度确认邮件', permList)) +
            ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />低度确认邮件(无回执)</span>
        <div v-if="isShowTabContent" style="margin: 25px 15px 15px">
          <p style="margin-bottom: 6px">请填写低度/高风险的判断依据:</p>
          <p style="color: red; margin-bottom: 6px">
            例1：根据第三方调查公司调查发现/经审查您提交的材料，2019年XX月XX日在内江市第一人民医院的病理检查诊断报告（病理号：F1800991、B1803523），病理诊断为：1、（右肺上叶结节）腺癌，小灶区间伴间质浸润；2、“右肺上叶”支气管切缘未见癌累及，余肺组织多切面未见癌残留；其余淋巴结未见癌转移。
          </p>
          <p style="color: red; margin-bottom: 12px">
            例2：2018年10月30日15时许，会员张加强在江西省赣州市兴国县永丰乡西江水库路段施工时，因意外倒地，被驶过的自卸货车撞伤，经送兴国县人民医院抢救无效当日死亡。
          </p>
          <el-input
            v-model="templateInfo.riskJudgmentBasis"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="请填写低度/高风险的判断依据"
          />
          <br>
          <p style="margin-bottom: 6px">意外风险类型（意外案件必填）:</p>
          <el-select v-model="riskInfo" multiple placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>
      <el-tab-pane
        v-if="tabInArray('tab07')"
        name="tab18"
        :label="
          (caseCode != '' || checkPermission('邮件:低度确认邮件', permList)) +
            ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />低度确认邮件(有回执)</span>
        <div v-if="isShowTabContent" style="margin: 25px 15px 15px">
          <p style="margin-bottom: 6px">请填写低度/高风险的判断依据:</p>
          <p style="color: red; margin-bottom: 6px">
            例1：根据第三方调查公司调查发现/经审查您提交的材料，2019年XX月XX日在内江市第一人民医院的病理检查诊断报告（病理号：F1800991、B1803523），病理诊断为：1、（右肺上叶结节）腺癌，小灶区间伴间质浸润；2、“右肺上叶”支气管切缘未见癌累及，余肺组织多切面未见癌残留；其余淋巴结未见癌转移。
          </p>
          <p style="color: red; margin-bottom: 12px">
            例2：2018年10月30日15时许，会员张加强在江西省赣州市兴国县永丰乡西江水库路段施工时，因意外倒地，被驶过的自卸货车撞伤，经送兴国县人民医院抢救无效当日死亡。
          </p>
          <el-input
            v-model="templateInfo.riskJudgmentBasis"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="请填写低度/高风险的判断依据"
          />
          <br>
          <p style="margin-bottom: 6px">意外风险类型（意外案件必填）:</p>
          <el-select v-model="riskInfo" multiple placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>
      <el-tab-pane
        v-if="tabInArray('tab13')"
        name="tab13"
        :label="
          (caseCode != '' ||
            checkPermission('邮件:互助申请进度通知', permList)) + ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />互助申请进度通知</span>
        <p v-if="isShowTabContent" style="margin: 25px 15px 15px">邮件内容:</p>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>
      <el-tab-pane
        v-if="tabInArray('tab08')"
        name="tab08"
        :label="
          (caseCode != '' ||
            checkPermission('邮件:不予互助通知邮件', permList)) + ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />不予互助通知邮件</span>

        <div v-if="isShowTabContent" style="margin: 25px 15px 15px">
          <p style="margin-bottom: 6px">请填写相关材料中的不予互助依据:</p>
          <p style="color: red; margin-bottom: 12px">
            例：根据第三方调查公司调查发现/经审查您提交的材料，您于2015年12月5日至2015年12月14日有在龙岩市人民医院肾内内分泌科的住院，出院诊断：2型糖尿病、糖尿病酮症、糖尿病周围神经病变2、慢性乙型病毒性肝炎3、冠状动脉粥样硬化性心脏病？4、脂肪肝5、混合型高脂血症6、左侧疝气术后7、右胸背部脂肪瘤切除术后8、CA199升高待查9、右下肢静脉曲张。
          </p>
          <el-input
            v-model="templateInfo.refusalOrWithdrawalBasis"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="请填写相关材料中的不予互助依据"
          />
          <br>
          <br>
          <p style="margin-bottom: 6px">请填写不予互助原因:</p>
          <p style="color: red; margin-bottom: 12px">
            例：您于加入前及等待期内已经确诊患有糖尿病、冠心病。
          </p>
          <el-input
            v-model="templateInfo.refusalOrWithdrawalReason"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="请填写不予互助原因"
          />
        </div>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>
      <el-tab-pane
        v-if="tabInArray('tab14')"
        name="tab14"
        :label="
          (caseCode != '' || checkPermission('邮件:超期不予互助', permList)) +
            ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />超期不予互助</span>
        <div v-if="isShowTabContent">
          <p style="margin-bottom: 6px">回访日期:</p>
          <p style="color: red; margin-bottom: 12px">
            例：2020-01-01、2020-02-01。
          </p>
          <el-input
            v-model="templateInfo.answerDate"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="请填写回访日期"
          />
          <br>
          <br>
          <template
            v-if="
              newCases != null &&
                newCases.flowCode != null &&
                newCases.flowCode != '100025'
            "
          >
            <p style="margin-bottom: 6px">提醒日期(退出计划必填):</p>
            <p style="color: red; margin-bottom: 12px">
              例：2020-01-01、2020-02-01。
            </p>
            <el-input
              v-model="templateInfo.remindDate"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="提醒日期(退出计划必填)"
            />
          </template>
        </div>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>

      <el-tab-pane
        v-if="tabInArray('tab15')"
        name="tab15"
        :label="
          (caseCode != '' || checkPermission('邮件:审批通过通知函', permList)) +
            ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />审批通过通知函(无回执)</span>
        <br>
        <div v-if="isShowTabContent" class="search-con">
          <!-- <div class="search-con-item">
            <label class="search-con-item__label">最高互助金额:</label>
            <span
              ><el-input
                placeholder="最高互助金额"
                v-model="templateInfo.maxHelpMoney"
              ></el-input
            ></span>
            <span style="color: #99a9bf; margin-right: 10px; margin-left: 10px"
              >元</span
            >
          </div> -->
        </div>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>

      <el-tab-pane
        v-if="tabInArray('tab19')"
        name="tab19"
        :label="
          (caseCode != '' || checkPermission('邮件:审批通过通知函', permList)) +
            ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />审批通过通知函(有回执)</span>
        <br>
        <div v-if="isShowTabContent" class="search-con">
          <!--  <div class="search-con-item">
            <label class="search-con-item__label">最高互助金额:</label>
            <span
              ><el-input
                placeholder="最高互助金额"
                v-model="templateInfo.maxHelpMoney"
              ></el-input
            ></span>
            <span style="color: #99a9bf; margin-right: 10px; margin-left: 10px">元</span>

          </div>-->
        </div>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>

      <el-tab-pane
        v-if="tabInArray('tab16')"
        name="tab16"
        :label="
          (caseCode != '' ||
            checkPermission('邮件:资料未完整撤案邮件', permList)) + ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />资料未完整撤案邮件</span>
        <div v-if="isShowTabContent" style="margin: 25px 15px 15px">
          <p style="margin-bottom: 6px">请填写撤案原因:</p>
          <el-input
            v-model="templateInfo.refusalOrWithdrawalReason"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="请填写撤案原因"
          />
        </div>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>
      <!--		<el-tab-pane name="tab10">
				<span slot="label"><i class="iconfont icon-email" style="margin-right: 4px;"></i>少儿呼吸道不予互助</span>
				<div style="margin:25px 15px 15px;" v-if="isShowTabContent">
					<p style="margin-bottom: 6px;">请填写相关材料中的不予互助依据:</p>
					<p style="color:red; margin-bottom: 12px;">例：根据第三方调查公司调查发现/经审查您提交的材料，您于2015年12月5日至2015年12月14日有在龙岩市人民医院肾内内分泌科的住院，出院诊断：2型糖尿病、糖尿病酮症、糖尿病周围神经病变2、慢性乙型病毒性肝炎3、冠状动脉粥样硬化性心脏病？4、脂肪肝5、混合型高脂血症6、左侧疝气术后7、右胸背部脂肪瘤切除术后8、CA199升高待查9、右下肢静脉曲张。</p>
					<el-input
						v-model="templateInfo.refusalOrWithdrawalBasis"
						type="textarea"
						:autosize="{ minRows: 5, maxRows: 10}"
						placeholder="请填写相关材料中的不予互助依据"
					</el-input>
					<br>
					<br>
					<p style="margin-bottom: 6px;">请填写不予互助原因:</p>
					<p style="color:red; margin-bottom: 12px;">例：您于加入前及等待期内已经确诊患有糖尿病、冠心病。</p>
					<el-input
						v-model="templateInfo.refusalOrWithdrawalReason"
						type="textarea"
						:autosize="{ minRows: 5, maxRows: 10}"
						placeholder="请填写不予互助原因"
					</el-input>
				</div>
			</el-tab-pane>-->
      <!-- 场景一，点击 发送邮件通知，只显示有权限的tab，这时候应该是 true && (false || true/false)
			场景二，点击 下一步，有/没有权限，且有显示某个tab，这时候应该是 true && (true || true/false)
			场景三，点击 下一步，有/没有权限，且不显示某个tab，这时候应该是 false && (true || true/false) -->
      <el-tab-pane
        v-if="tabInArray('tab09')"
        name="tab09"
        :label="
          (caseCode != '' || checkPermission('邮件:撤案邮件', permList)) + ''
        "
      >
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />非互助范围撤案邮件</span>
        <div v-if="isShowTabContent" style="margin: 25px 15px 15px">
          <p style="margin-bottom: 6px">请填写相关材料中的撤案依据:</p>
          <p style="color: red; margin-bottom: 12px">
            例：根据您所提交的材料显示，您于2019年4月11日在中国医学科学院肿瘤医院进行病理诊断，诊断结果为：肺原位鳞状细胞癌。
          </p>
          <el-input
            v-model="templateInfo.refusalOrWithdrawalBasis"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="请填写相关材料中的撤案依据"
          />
          <br>
          <br>
          <p style="margin-bottom: 6px">请填写撤案原因:</p>
          <p style="color: red; margin-bottom: 12px">
            例：根据《国际疾病分类肿瘤学专辑》（ICD-O）该疾病属于原位癌。
          </p>
          <el-input
            v-model="templateInfo.refusalOrWithdrawalReason"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="请填写撤案原因"
          />
        </div>
        <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
      </el-tab-pane>

      <el-tab-pane v-if="tabInArray('tab17')" name="tab17" :label="'true'">
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />超期未缴费邮件</span>
        <p style="margin: 25px 15px 15px">邮件内容:</p>
      </el-tab-pane>
      <el-tab-pane v-if="tabInArray('tab00')" name="tab00" :label="'true'">
        <span
          slot="label"
        ><i
          class="iconfont icon-email"
          style="margin-right: 4px"
        />通用邮件</span>
        <div class="search-con">
          <br>
          <div class="search-con-item">
            <label class="search-con-item__label">邮件标题:</label>
            <span
              style="width: 400px"
            ><el-input
              v-model="sendInfo.mailName"
              placeholder="请填写邮件标题"
            /></span>
          </div>
          <br>
          <div class="search-con-item">
            <label class="search-con-item__label">邮件内容:</label>
          </div>
        </div>
      </el-tab-pane>

      <!-- 新增邮件模版（2022-05-31） -->
      <template>
        <el-tab-pane
          v-if="tabInArray('tab20')"
          name="tab20"
          :label="
            (caseCode != '' ||
              checkPermission('邮件:立案收费邮件（爱心版）', permList)) + ''
          "
        >
          <span
            slot="label"
          ><i
            class="iconfont icon-email"
            style="margin-right: 4px"
          />立案收费邮件（爱心版）</span>
          <br>
          <div v-if="isShowTabContent" class="search-con">
            <div class="search-con-item">
              <label class="search-con-item__label">调查费用:</label>
              <span><el-input
                v-model="templateInfo.surveyMoney"
                placeholder="调查费用"
              /></span>
              <span
                style="color: #99a9bf; margin-right: 10px; margin-left: 10px"
              >元</span>
            </div>
          </div>
          <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
        </el-tab-pane>
        <el-tab-pane
          v-if="tabInArray('tab21')"
          name="tab21"
          :label="
            (caseCode != '' ||
              checkPermission('邮件:通知调查邮件（爱心版）', permList)) + ''
          "
        >
          <span
            slot="label"
          ><i
            class="iconfont icon-email"
            style="margin-right: 4px"
          />通知调查邮件（爱心版）</span>
          <p v-if="isShowTabContent" style="margin: 25px 15px 15px">
            邮件内容:
          </p>
          <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
        </el-tab-pane>
        <el-tab-pane
          v-if="tabInArray('tab22')"
          name="tab22"
          :label="
            (caseCode != '' ||
              checkPermission(
                '邮件:不予互助通知邮件（主动放弃申请）',
                permList
              )) + ''
          "
        >
          <span
            slot="label"
          ><i
            class="iconfont icon-email"
            style="margin-right: 4px"
          />不予互助通知邮件（主动放弃申请）</span>
          <p v-if="isShowTabContent" style="margin: 25px 15px 15px">
            邮件内容:
          </p>
          <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
        </el-tab-pane>
        <el-tab-pane
          v-if="tabInArray('tab23')"
          name="tab23"
          :label="
            (caseCode != '' || checkPermission('邮件:爱心确认邮件', permList)) +
              ''
          "
        >
          <span
            slot="label"
          ><i
            class="iconfont icon-email"
            style="margin-right: 4px"
          />爱心确认邮件</span>
          <p v-if="isShowTabContent" style="margin: 25px 15px 15px">
            邮件内容:
          </p>
          <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
        </el-tab-pane>
        <el-tab-pane
          v-if="tabInArray('tab24')"
          name="tab24"
          :label="
            (caseCode != '' ||
              checkPermission('邮件:首封后提醒邮件', permList)) + ''
          "
        >
          <span
            slot="label"
          ><i
            class="iconfont icon-email"
            style="margin-right: 4px"
          />首封后提醒邮件</span>
          <p v-if="isShowTabContent" style="margin: 25px 15px 15px">
            邮件内容:
          </p>
          <div v-else class="null-txt">暂无权限使用这个邮件模板</div>
        </el-tab-pane>
      </template>

      <editor v-if="showEdit" :value="editor.info" @changeInfo="changeInfo" />
      <br>
      <div v-if="showButton" style="margin: 0px 15px 25px">
        <el-button
          v-if="_isShowGenerateButton()"
          type="primary"
          icon="iconfont icon-diaochabiao"
          :loading="getloading"
          @click.stop="getTemplateInfo"
        >
          生 成
        </el-button>
        <el-button
          v-if="
            (showEdit || templateInfo.templateType == 100000) &&
              checkPermission('电子材料:发送邮件通知:发送', permList)
          "
          type="primary"
          icon="iconfont icon-email"
          :loading="sendloading"
          @click="sendMail"
        >
          发 送
        </el-button>
        <el-badge
          v-if="
            (showEdit || templateInfo.templateType == 100000) &&
              checkPermission('设置定时发邮件', permList)
          "
          :value="timeingEmailValue"
          class="item"
          style="margin: 0px 10px"
        >
          <el-button
            type="primary"
            icon="iconfont icon-email"
            :disabled="isTimeingEmail"
            :loading="sendTimeingLoading"
            @click="sendTimeingEmail"
          >
            设置定时发邮件
          </el-button>
        </el-badge>
        <el-button
          v-if="
            showEdit &&
              showSendMsgBtn &&
              checkPermission('电子材料:发送邮件通知:发送', permList)
          "
          type="primary"
          icon="iconfont icon-email"
          :loading="sendmsgloading"
          @click="sendMessage"
        >
          发送短信
        </el-button>
        <el-button
          v-if="caseCode != ''"
          type="primary"
          icon="iconfont"
          style="float: right"
          @click="updateFlow"
        >
          下一步
        </el-button>
      </div>
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Editor from '@/components/Editor' // 富文本编辑器

export default {
  name: 'SendEmail',
  components: {
    Editor
  },
  props: {
    showEmailTab: {
      type: Array,
      default: () => []
    },
    showEmailCode: {
      type: Number,
      default: 32
    },
    caseCode: {
      type: String,
      default: ''
    },
    showEmailMsg: {
      type: String,
      default: ''
    },
    version: {
      type: Number,
      default: 0
    },
    cases: {
      type: Object,
      default: () => {}
    },
    // 判断当前刷新按钮是否显示
    isRefreshBtn: {
      type: Boolean,
      default: () => true
    }
  },

  data() {
    return {
      newCases: {}, // 案件信息
      activeTab: '',
      templateTypeArr: [
        '100000',
        '100001',
        '100002',
        '100003',
        '100006',
        '100007',
        '100008',
        '100009',
        '100013',
        '100014',
        '100015',
        '100016',
        '100017',
        '100018',
        '100019'
      ],
      // 内容对象
      templateInfo: {
        caseCode: null,
        templateType: 0,
        maxHelpMoney: null,
        minHelpMoney: null,
        surveyMoney: null,
        addContent: null,
        riskJudgmentBasis: null,
        refusalOrWithdrawalBasis: null,
        refusalOrWithdrawalReason: null,
        answerDate: null,
        remindDate: null,
        riskType: null
      },
      // 发送的对象
      sendInfo: {
        caseCode: null,
        templateType: 0,
        mailContent: null,
        mailName: null
      },
      uploadUrl: null,
      quillEditor: null,
      showEdit: false,
      showButton: false,
      editor: {
        info: '',
        newInfo: ''
      },
      isClear: false,
      sendloading: false,
      sendTimeingLoading: false,
      sendmsgloading: false,
      getloading: false,
      showSendMsgBtn: false,
      isTimeingEmail: false,
      riskInfo: [],
      options: [
        {
          value: '高风险运动',
          label: '高风险运动'
        },
        {
          value: '高风险职业',
          label: '高风险职业'
        },
        {
          value: '高风险作业',
          label: '高风险作业'
        }
      ],
      isShowTabContent: true
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    }),

    timeingEmailValue() {
      return this.isTimeingEmail ? '已设置' : ''
    }
  },

  watch: {
    version() {
      this.templateInfo.templateType = 0
      this.activeTab = ''
      this.showEdit = false
    },

    showEmailCode() {
      this.templateInfo.templateType = 0
      this.activeTab = ''
      this.showEdit = false
      this.showButton = false
    },

    /**
     * 监听cases的变化，并数据赋予给newCases
     */
    cases(val, oldVal) {
      if (val !== oldVal) {
        this.newCases = val
      }
    }
  },

  created() {
    this.$emit('setCurrentMenu', '发送邮件通知')
  },

  methods: {
    back() {
      this.$router.go(-1)
    },

    // 当前模板是否显示
    tabInArray(tabName) {
      // 如果props入参没有caseCode，说明是通过路由进来的，那所有tab都显示
      if (this.caseCode === '') return true

      var isExists = false
      this.showEmailTab.forEach((emailItem) => {
        if (tabName === emailItem) {
          isExists = true
        }
      })
      return isExists
    },

    changeTab(tab, event) {
      const vm = this
      // 是否有权限操作当前模板
      if (tab.label === 'undefined' || tab.label === 'false') {
        vm.isShowTabContent = false
        vm.showButton = false
        vm.showEdit = false
        return false
      } else {
        vm.isShowTabContent = true
      }

      var flowCode = vm.$route.params.flowCode
      if (flowCode !== 'undefined' && flowCode != null) {
        var obj = {
          flowCode: flowCode
        }
        vm.newCases = obj
      }

      event.stopPropagation()
      event.preventDefault()
      Object.assign(this.$data.templateInfo, this.$options.data().templateInfo)
      vm.riskInfo = []
      const templateType = parseInt('1000' + tab.name.substr(3))
      vm.templateInfo.templateType = templateType
      if (vm._isShowEditor(templateType)) {
        // 预览邮件内容
        vm.getTemplateInfo()
      } else if (templateType === 100000) {
        // 通用邮件
        vm.showEdit = true
        vm.editor.info = ''
        vm.editor.newInfo = ''
        vm.checkIsTimeingEmail()
      } else {
        vm.showEdit = false
      }
      vm.showButton = true
      vm.showSendMsg()
    },

    updateFlow() {
      this.$emit('updateFlow', this.showEmailCode, this.showEmailMsg)
    },

    /**
     * 案件手工发送邮件结果
     */
    showSendMsg() {
      const vm = this
      const { templateType } = vm.templateInfo
      const { caseCode } = vm.$route.params

      vm.axios
        .get(vm.homePath() + '/casesCommon/getMailSendResult', {
          params: {
            caseCode,
            templateType
          }
        })
        .then((res) => {
          if (res.data.status === '000000') {
            vm.showSendMsgBtn = res.data.result
          } else {
            vm.$alert(res.data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    /**
     * 当前案件邮件类型是否存在未发送定时任务
     */
    checkIsTimeingEmail() {
      const vm = this
      const { templateType } = vm.templateInfo
      const { caseCode } = vm.$route.params

      vm.axios
        .get(vm.homePath() + '/casesCommon/getTimerSendMailResult', {
          params: {
            caseCode,
            templateType
          }
        })
        .then((res) => {
          if (res.data.status === '000000') {
            vm.isTimeingEmail = res.data.result
          } else {
            vm.$alert(res.data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    /**
     * 自定义邮件发送-预览接口
     */
    getTemplateInfo() {
      const { templateInfo, riskInfo } = this
      const { templateType } = templateInfo
      const { caseCode } = this.$route.params
      this.getloading = true
      this.templateInfo.caseCode = caseCode

      if (
        (Number(templateType) === 100007 || Number(templateType) === 100018) &&
        riskInfo.length > 0
      ) {
        this.templateInfo.riskType = this.riskInfo.join('、')
      }
      this.axios({
        url: this.homePath() + '/casesCommon/getMailMessage',
        method: 'put',
        data: this.templateInfo,
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const result = res.data
          if (result.status === '000000') {
            this.sendInfo.mailContent = result.data.mailContent
            this.sendInfo.maxHelpMoney = result.data.maxHelpMoney
            this.sendInfo.minHelpMoney = result.data.minHelpMoney
            this.sendInfo.surveyMoney = result.data.surveyMoney
            this.sendInfo.mailName = result.data.mailName
            this.editor.info = result.data.mailContent
            this.editor.newInfo = result.data.mailContent
            this.showEdit = true
            this.showButton = true
            this.checkIsTimeingEmail()
          } else {
            this.$alert(result.message)
          }

          this.getloading = false
        })
        .catch((error) => {
          console.log(error)
        })
    },

    changeInfo(val) {
      this.editor.newInfo = val
    },

    sendMail() {
      const vm = this
      vm.$confirm('确定要操作发送邮件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async() => {
          setTimeout(function() {
            vm.sendloading = true
            vm.send()
          }, 100)
        })
        .catch(() => {
          console.log('取消发送')
        })
    },

    sendTimeingEmail() {
      const vm = this
      vm.$confirm('确定要操作定时发送邮件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async() => {
          setTimeout(function() {
            vm.sendTimeingLoading = true
            vm.sendTimeing()
          }, 100)
        })
        .catch(() => {
          console.log('取消发送')
        })
    },

    sendMessage() {
      const vm = this
      vm.$confirm('确定要操作发送短信吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async() => {
          setTimeout(function() {
            vm.sendmsgloading = true
            vm.sendMsg()
          }, 100)
        })
        .catch(() => {
          console.log('取消发送')
        })
    },

    send() {
      const vm = this
      // const sendStatus = false
      const { caseCode } = vm.$route.params
      vm.sendInfo.caseCode = caseCode
      vm.sendInfo.mailContent = vm.editor.newInfo
      vm.sendInfo.templateType = vm.templateInfo.templateType
      vm.axios({
        url: vm.homePath() + '/casesCommon/handSendMail',
        method: 'put',
        data: vm.sendInfo,
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const result = res.data
          vm.$alert(result.message, '提示')
          vm.sendloading = false
          vm.showSendMsg()
          this.$emit('getcaseInfo')
        })
        .catch((error) => {
          console.log(error)
        })
    },

    sendTimeing() {
      const vm = this
      // const sendStatus = false
      const { caseCode } = vm.$route.params
      vm.sendInfo.caseCode = caseCode
      vm.sendInfo.mailContent = vm.editor.newInfo
      vm.sendInfo.templateType = vm.templateInfo.templateType
      vm.axios({
        url: vm.homePath() + '/casesCommon/timerSendMail',
        method: 'put',
        data: vm.sendInfo,
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const result = res.data
          vm.$alert(result.message, '提示')
          vm.sendTimeingLoading = false
          vm.checkIsTimeingEmail()
        })
        .catch((error) => {
          console.log(error)
        })
    },

    sendMsg() {
      const vm = this
      // const sendStatus = false
      const { caseCode } = vm.$route.params
      vm.axios
        .get(vm.homePath() + '/casesCommon/handSendSMS', {
          params: {
            caseCode: caseCode,
            templateType: vm.templateInfo.templateType
          }
        })
        .then((res) => {
          const result = res.data
          vm.$alert(result.message, '提示')
          vm.sendmsgloading = false
          this.$emit('getcaseInfo')
        })
        .catch((error) => {
          console.log(error)
        })
    },

    /**
     * 判断邮件富文本内容是否显示
     * @param {number} templateType 邮件的模版类型
     */
    _isShowEditor(templateType) {
      return (
        templateType === 100001 ||
        templateType === 100006 ||
        templateType === 100013 ||
        templateType === 100021 ||
        templateType === 100022 ||
        templateType === 100023 ||
        templateType === 100024
      )
    },

    /**
     * 判断生成按钮是否显示
     */
    _isShowGenerateButton() {
      const { permList } = this
      const { templateType } = this.templateInfo

      return (
        Number(templateType) !== 0 &&
        Number(templateType) !== 100001 &&
        Number(templateType) !== 100006 &&
        Number(templateType) !== 100000 &&
        Number(templateType) !== 100013 &&
        Number(templateType) !== 100021 &&
        Number(templateType) !== 100022 &&
        Number(templateType) !== 100023 &&
        Number(templateType) !== 100024 &&
        this.checkPermission('电子材料:发送邮件通知:生成', permList)
      )
    }
  }
}
</script>

<style scoped>
.el-badge__content.is-fixed {
  right: 45px;
}
.null-txt {
  padding: 20px 20px 0;
}
</style>
